import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/shared/hooks/useAuth";
import { useIsLawyer, getCachedLawyerStatus } from "@/shared/hooks/useIsLawyer";
import CircularProgress from "@/shared/components/CircularProgress";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { LAWYER_ROUTES, POST_LOSS_ROUTES } from "@/shared/constants/paths";
import { LawyerSignupProvider } from "@/pages/lawyer/signup/LawyerSignupContext";

function LawyerAuthGuard() {
  const { user: authUser, loading } = useAuth();
  const { isLawyer, isLoading: lawyerLoading } = useIsLawyer();
  const location = useLocation();

  const isVerifyRoute = location.pathname === LAWYER_ROUTES.SIGNUP_VERIFY;
  const isProfileRoute = location.pathname === LAWYER_ROUTES.SIGNUP_PROFILE;

  if (getCachedLawyerStatus() && !isProfileRoute) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  const signupEmail = sessionStorage.getItem("lawyer_signup_email");
  const isSignupSubRoute = isVerifyRoute || isProfileRoute;

  if (loading || lawyerLoading) {
    if ((isVerifyRoute && signupEmail) || isProfileRoute) {
      return <Outlet />;
    }
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  if (authUser && isLawyer && !isProfileRoute) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  if (isSignupSubRoute) {
    if (isVerifyRoute && signupEmail) {
      return <Outlet />;
    }
    if (isProfileRoute && (authUser || signupEmail)) {
      return <Outlet />;
    }
    if (authUser) {
      return <Navigate to={POST_LOSS_ROUTES.OVERVIEW} replace />;
    }
    return <Navigate to={LAWYER_ROUTES.SIGNUP} replace />;
  }

  if (authUser) {
    return <Navigate to={POST_LOSS_ROUTES.OVERVIEW} replace />;
  }

  return <Outlet />;
}

export function LawyerAuthRouteWrapper() {
  return (
    <LawyerSignupProvider>
      <LawyerAuthGuard />
    </LawyerSignupProvider>
  );
}
